import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SafeUrlPipeModule } from '../pipes/safe-url.pipe';
import { TranslatePipeModule } from '../shared/translate.pipe';
import { WindowService } from '../shared/window.service';
import { PrivateClassesPageComponent } from './private-classes-page/private-classes-page.component';
import { UserwaySyncModule } from '../shared/userway-sync.directive';

@NgModule({
  imports: [CommonModule, TranslatePipeModule, SafeUrlPipeModule, UserwaySyncModule],
  declarations: [PrivateClassesPageComponent],
  providers: [WindowService],
})
export class PrivateClassesModule {}



// WEBPACK FOOTER //
// ./ts/app/private-classes/private-classes.module.ts